import { createRoute } from '@tanstack/react-router';

import { clientRoute } from '../route';

export const clientDocumentsRoute = createRoute({
	path: '/documents',
	getParentRoute: () => clientRoute,
});
